import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ICtoContract, ICtoEvent } from '../../../core/models/cto.model';
import { CtoApiService } from '../../../core/modules/cto/cto-api.service';
import { KkmsApiService } from '../../../core/modules/kkms/kkms-api.service';
import { IRetailPlace } from '../../../core/modules/retail-places/retail-paces.types';

@Component({
  selector: 'tax-cto-kkm-history',
  templateUrl: './cto-kkm-history.component.html',
  styleUrls: ['./cto-kkm-history.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class CtoKkmHistoryComponent implements OnInit, OnDestroy {
  // @ts-ignore
  retailPlaceData: IRetailPlace;
  // @ts-ignore
  contract: ICtoContract;
  // @ts-ignore
  kkmHistory: Array<ICtoEvent>;
  tags: Array<string> = [];
  selectedTags: Array<string> = [];
  private subscription: Subscription[] = [];

  constructor(
    private ctoApiService: CtoApiService,
    private kkmsApiService: KkmsApiService,
    private changeDetector: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    // @ts-ignore
    const kkmId: string = this.activatedRoute.snapshot.paramMap.get('kkmId');
    // @ts-ignore
    const contractId: string = this.activatedRoute.snapshot.paramMap.get('ctoId');
    this.subscription.push(
      this.getContract(contractId),
      this.getKkmHistory(kkmId),
      this.getRetailPlaceData(kkmId),
    );
  }

  ngOnDestroy(): void {
    this.subscription.forEach((item: Subscription) => item.unsubscribe());
  }

  getContract(contractId: string | number): Subscription {
    return this.ctoApiService.fetchContract(contractId.toString()).subscribe(
      (response: ICtoContract) => {
        this.contract = response;
        this.changeDetector.markForCheck();
      },
    );
  }

  selectTag(tag: string): void {
    if (this.selectedTags.includes(tag)) {
      this.selectedTags.splice(this.selectedTags.indexOf(tag), 1);
    } else {
      this.selectedTags.push(tag);
    }
  }

  getFilteredHistory(events: Array<ICtoEvent>): Array<ICtoEvent> {
    if (!this.selectedTags.length) {
      return events;
    }
    return events.filter(event => this.selectedTags.includes(event.type));
  }

  private getKkmHistory(kkmId: string): Subscription {
    return this.ctoApiService.fetchKkmHistory(kkmId).subscribe(
      (response) => {
        this.kkmHistory = response;
        this.tags = [...new Set(this.kkmHistory.map((item: ICtoEvent) => item.type))];
        this.changeDetector.markForCheck();
      },
    );
  }

  private getRetailPlaceData(kkmId: string): Subscription {
    return this.kkmsApiService.fetchKkmsByCriteria({
      criteria: kkmId,
      pagination: {
        from: 0, to: 1,
      },
    }).subscribe(
      (response) => {
        this.retailPlaceData = response[0];
        this.changeDetector.markForCheck();
      },
    );
  }
}
